import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { plainToInstance } from 'class-transformer';
import { Event } from '../models/event.model';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private apiUrl = `${environment.sgcApi}`;
  private eventRoute = 'event';

  constructor(
    private httpClient: HttpClient,
  ) {}

  getEvents() : Observable<Event[]> {
    let endpoint = `${this.apiUrl}${this.eventRoute}`;
    return this.httpClient.get<Event[]>(endpoint)
    .pipe(map((data) => {
      return plainToInstance(Event, data as Event[]);
    }));
  }
}
